import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=5b279e9a"
import script from "./SidebarContainer.vue?vue&type=script&lang=js"
export * from "./SidebarContainer.vue?vue&type=script&lang=js"
import style0 from "./SidebarContainer.vue?vue&type=style&index=0&id=5b279e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports